module.exports = __webpack_public_path__ + "static/media/cancel.8f6b00e8.svg";